import { colors, getVal, LABEL, TagDisplayV2 } from "oolib";
import React from "react";
import styled, { css, useTheme } from "styled-components";
import { parseSpecialSyntax } from "../../../../utils/parseSpecialSyntax";


const StyledWrapper = styled.div`
display: flex;
align-items: center;
gap: 1rem;
${({align}) => align === 'center'
  && css`
    justify-content: center;
  `}
`

export const MetaPrimary = ({
  prefix,
  prefixPath,
  value,
  valuePath,
  content,
  invert,
  align = 'center',
  tpl, //only available if rendered in tci
  TextComp
}) => {

  const theme = useTheme()

  const Comp = TextComp || TagDisplayV2;

  if(!content) content.map(d => {}) //content prop is compulsory. this way we force a blank screen if content is not passed
  if(!value && !prefix && !prefixPath && !valuePath) return null;



  const genPrefix = () => {
    if(!prefix && !prefixPath) return null;

    let text = prefix ? (parseSpecialSyntax({string: prefix, content, tpl}) || prefix) : getVal(content, prefixPath)
    return (
      <Comp style={invert ? {color: colors.greyColor15} : {} /** invert thing is temp till we transition to new UI*/ }>
        {text}
      </Comp>
    )
  }

  const genValue = () => {
    if(!value && !valuePath) return null;
    let text = value ? (parseSpecialSyntax({string: value, content, tpl}) || value) : getVal(content, valuePath)
    return (
      <Comp style={{ color: colors}} display={text} XS>
        {text}
      </Comp>
    )
  }

  return (
    <StyledWrapper align={align}>
      {genPrefix()}
      {genValue()}
    </StyledWrapper>
  );
};

